import styled from 'styled-components';

export const BannerBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 11px 56px;
  font-size: 14px;
  line-height: 1.35;
  text-align: center;
  background-color: #eef3f2;
  border-bottom: 1px solid #d7e3e1;
`;

export const IconCircle = styled.span`
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background: ${({ theme }) => theme.color.primary};
  color: ${({ theme }) => theme.color.white};
`;

export const TextWrapper = styled.div`
  min-width: 0;
  color: ${({ theme }) => theme.color.defaultText};

  strong {
    font-weight: 700;
    color: ${({ theme }) => theme.color.primary};
  }
`;

export const SubText = styled.span`
  display: block;
  font-size: 12.5px;
  opacity: 0.65;
  margin-top: 1px;
`;

export const CtaLink = styled.a`
  flex: 0 0 auto;
  text-decoration: none;
  font-weight: 600;
  font-size: 13px;
  padding: 7px 16px;
  border-radius: 6px;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.color.primary};
  color: ${({ theme }) => theme.color.white};

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.color.white};
    opacity: 0.9;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  cursor: pointer;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: ${({ theme }) => theme.color.gray2};
  opacity: 0.6;

  &:hover {
    opacity: 1;
    background: rgba(0, 0, 0, 0.06);
  }
`;
